<template>
  <i :class="['TkDownArrow', `-${size}`]" />
</template>

<script>
export default {
  name: 'TkDownArrow',
  props: {
    size: {
      type: String,
      default: 'normal', // 'normal', 'large', 'x-large' が指定可能
    },
  },
}
</script>

<style lang="scss">
.TkDownArrow {
  &::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    content: "";
    vertical-align: middle;
  }

  &::after {
    border-right: 2px solid;
    border-top: 2px solid;
    position: absolute;
    top: 0;
    bottom: 3px;
    left: 3px;
    margin: auto;
    content: "";
    vertical-align: middle;
    transform: rotate(135deg);
  }

  &.-normal {
    &::after {
      height: 5px;
      width: 5px;
    }
  }

  &.-large {
    &::after {
      height: 7px;
      width: 7px;
    }
  }

  &.-x-large {
    &::after {
      height: 9px;
      width: 9px;
    }
  }
}
</style>
